// ————————————————————————————————————————————— DOC. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { gsap } from "gsap";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default {
  /////////////////////////// Route selection ////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  from: /^\/(?!test-overlay-page).*$/, // ← any route but '/test-overlay-page'
  to: /^\/(?!test-overlay-page).*$/, // ← any route but '/test-overlay-page'

  ///////////////////////////////// Out //////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  out: async () => {
    // Slide up + fade out...
    await gsap.to("#swup", { opacity: 0, y: -50, duration: 0.333 });
  },

  ///////////////////////////////// In ///////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  in: async () => {
    // Slide down + fade in...
    await gsap.fromTo("#swup", { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 0.333 });
  },
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
